import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import differenceInDays from 'date-fns/differenceInDays';
import isPast from 'date-fns/isPast';
import { Clock } from '@styled-icons/feather/Clock';
import useTranslation from 'next-translate/useTranslation';
import { style, Raffle } from '../../../api';

import { TextBold14, TextRegular12 } from '../../common/Text';
import {
  isLessThanADay,
  formatDateUntil,
} from '../../../utils/formatDateUntil';

const TimeLeftUnstyled = ({
  className,
  raffle,
}: {
  className?: string;
  raffle: Raffle;
}) => {
  const { t } = useTranslation('contests');
  const { closed_at, remix_contest, contest } = raffle;
  const type = remix_contest || contest ? 'Contest' : 'Raffle';
  const isOver = isPast(new Date(closed_at * 1000));
  const almostRunningOut =
    Math.abs(differenceInDays(closed_at, Date.now())) < 7;
  const updateInterval = isLessThanADay(closed_at);
  const formattedDate = formatDateUntil(
    closed_at,
    t('common:days') as string,
    t('common:seconds') as string,
  );
  const [timeMessage, setTimeMessage] = useState(formattedDate);

  useEffect(() => {
    let interval: number | undefined | NodeJS.Timeout;
    if (updateInterval) {
      interval = setInterval(() => setTimeMessage(formattedDate), 1000);
    }

    return () => {
      if (updateInterval && interval) {
        clearInterval((interval as unknown) as number);
      }
    };
  });

  if (raffle.type === 'open_demo_submission') {
    return (
      <TimeLeftWrapper className={className}>
        <Clock size={12} color={style.black_new} />

        <span
          className="custom-font-text-tiny-normal"
          style={{ color: style.success_new }}
        >
          {t('contests:timeLeft.open')}
        </span>
      </TimeLeftWrapper>
    );
  }

  if (isOver) {
    return (
      <TimeLeftWrapper className={className}>
        <Clock size={12} color={style.black_new} />
        <span className="custom-font-text-tiny-normal">
          {type} {t('contests:timeLeft.ended')}{' '}
        </span>
      </TimeLeftWrapper>
    );
  }

  return (
    <TimeLeftWrapper className={className}>
      <Clock size={12} color={style.black_new} />
      <span
        className="custom-font-text-small-medium"
        style={{ paddingRight: '3px' }}
      >
        {t('contests:timeLeft.ending')}
      </span>
      <span
        className="custom-font-text-small-medium"
        style={{
          color: almostRunningOut ? style.error_new : style.success_new,
        }}
      >
        {timeMessage}
      </span>
    </TimeLeftWrapper>
  );
};

const TimeLeftWrapper = styled.span`
  display: flex;
  align-items: center;
  height: 20px;

  svg {
    margin-right: 4px;
  }

  ${TextRegular12} {
    margin-right: 4px;
  }
`;

export default styled(TimeLeftUnstyled)``;

export const TimeLeftDetail = styled(TimeLeftUnstyled)`
  ${TextRegular12} {
    margin-right: 8px;
  }
  ${TextBold14} {
    font-size: 12px;
  }
`;
